import {
  GatewaysGetRequest,
  GatewaysGatewayIdGetRequest,
  GatewaysGatewayIdAccessKeysGetRequest,
  GatewaysGatewayIdAccessKeysKeyIdGetRequest,
  GatewaysBatchGetPostRequest,
} from '@nativewaves/nw-cloud-sdk/origin'
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { OriginAPI } from 'services/api'

const baseIdentifier = 'origin'

export const gatewayQueryKeys = {
  base: () => [baseIdentifier, 'gateway'] as const,
  lists: () => [...gatewayQueryKeys.base(), 'list'] as const,
  list: (params: GatewaysGetRequest) =>
    infiniteQueryOptions({
      queryKey: [...gatewayQueryKeys.lists(), params] as const,
      queryFn: ({ pageParam, signal }) => OriginAPI.gateways.gatewaysGet({ ...params, next: pageParam }, { signal }),
      initialPageParam: params.next,
      getNextPageParam: (lastPage) => (lastPage.next.length ? lastPage.next : null),
    }),
  batchGets: () => [...gatewayQueryKeys.base(), 'batch'] as const,
  batchGet: (
    params: Omit<GatewaysBatchGetPostRequest['originGatewayBatchGet'], 'ids'>,
    gatewayIdBatch: () => GatewaysBatchGetPostRequest['originGatewayBatchGet']['ids'],
  ) =>
    queryOptions({
      queryKey: [...gatewayQueryKeys.batchGets(), params] as const,
      queryFn: ({ signal }) =>
        OriginAPI.gateways.gatewaysBatchGetPost(
          { originGatewayBatchGet: { ...params, ids: gatewayIdBatch() } },
          { signal },
        ),
    }),
  details: () => [...gatewayQueryKeys.base(), 'detail'] as const,
  detail: (params: GatewaysGatewayIdGetRequest) =>
    queryOptions({
      queryKey: [...gatewayQueryKeys.details(), params] as const,
      queryFn: () => OriginAPI.gateways.gatewaysGatewayIdGet(params),
    }),
  accessKeyLists: () => [...gatewayQueryKeys.base(), 'access-key', 'list'] as const,
  accessKeyList: (params: GatewaysGatewayIdAccessKeysGetRequest) =>
    infiniteQueryOptions({
      queryKey: [...gatewayQueryKeys.accessKeyLists(), params] as const,
      queryFn: ({ pageParam, signal }) =>
        OriginAPI.gateways.gatewaysGatewayIdAccessKeysGet({ ...params, next: pageParam }, { signal }),
      initialPageParam: params.next,
      getNextPageParam: (lastPage) => (lastPage.next.length ? lastPage.next : null),
    }),
  accessKeyDetails: () => [...gatewayQueryKeys.base(), 'access-key', 'detail'] as const,
  accessKeyDetail: (params: GatewaysGatewayIdAccessKeysKeyIdGetRequest) =>
    queryOptions({
      queryKey: [...gatewayQueryKeys.accessKeyDetails(), params] as const,
      queryFn: () => OriginAPI.gateways.gatewaysGatewayIdAccessKeysKeyIdGet(params),
    }),
}
